// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".change-price-btn {\n  width: 90%;\n  margin-bottom: 1rem;\n  background-color: transparent !important;\n  border: 1px solid white;\n  color: white !important;\n}\n.container-change-price-tag {\n  background-color: transparent !important;\n  width: 100%;\n  padding: 1rem 0.8rem;\n}\n.container-change-price-tag .wrapper {\n  background-color: white !important;\n  padding: 1rem;\n  border-radius: 5px;\n}", ""]);
// Exports
module.exports = exports;
